export default __webpack_public_path__ + "static/media/dc67cc69d742fe987f747b900d4edff8.jpg";